export default __webpack_public_path__ + "img/ami-logo.a96ba4d5.png";